<template>
  <!-- <div class="covid-alert">
    <h3>COVID-19 Message:</h3>
    <p>
      We know the "norm" as we once knew it is unrecognizable and feeding
      students during COVID-19 is forcing you to think way outside the box. We
      have created a
      <router-link to="/NTFToolkit"
        >Non-Traditional Feeding Toolkit</router-link
      >
      product guide focused on items conducive to feeding your students during
      these unusual times. It includes key product information in an easy to
      read format as well as product pictures and detailed nutritional
      information. We are committed as ever to helping you through it all. Do
      not hesitate to contact us for help!
    </p>
  </div> -->
  <br />
  <p>
    <b>For your convenience, we have listed below several important documents we
    think are particularly relevant and useful, and that we wanted you to have
    easy access to. Please have a look at our <router-link to="/ProductGuides">Product Guides</router-link> for detailed
    product information!</b>
  </p>
  <br />
  <div v-if="!isLoading" class="important-docs">
    <h2>Important Documents</h2>
    <h4>Note: Product Nutritionals can be found by clicking on a product description in the <router-link to="/GFSStockList">GFS Stock List</router-link>.</h4>
    <br>
    <ImportantDocsTable :items="importantDocsList" />
  </div>


  <!-- start here -->
  
  <div class="header">
    <h1>Resources</h1>
  </div>
  <div>
    <ul id="resources">
        <li>
            <a href="./downloads/resources/Garricks_WebSCM_CheatSheet_Revised.doc" download>Garrick's WebSCM Cheat Sheet (revised)</a>
        </li>
        <li>
            <a href="./downloads/resources/NOI_Final.docx" download>NOI-Final</a>
        </li>
    </ul>
  </div>

  <div class="header">
    <h1>Buy American</h1>
  </div>
  <br />
  <div class="cards">
    <!-- <article class="card">
      <img src="../assets/mpk-ntf-toolkit-thumb.png" alt="Sample photo" />
      <div class="text">
        <h3>Non-Traditional Feeding Toolkit</h3>
        <br />
        <p>Focused on IW and products conducive to offsite feeding.</p>
        <br />
        <div class="showguide">
          <router-link to="/NTFToolkit">Show Guide</router-link>
        </div>
      </div>
    </article> -->
    <article class="card">
      <img src="../assets/logos/bakecrafters.jpg" alt="Bake Crafters" />
      <div class="text">
        <a href="./downloads/buyamerican/bakecrafters_ba.pdf" download>Bake Crafters Buy American Statement</a>
      </div>
    </article>
    <article class="card">
      <img src="../assets/logos/goldcreekfoods.jpg" alt="Gold Creek" />
      <div class="text">
        <a href="./downloads/buyamerican/goldcreek_ba.pdf" download>Gold Creek Buy American Statement</a>
      </div>
    </article>
    <article class="card">
      <img src="../assets/logos/jtm.png" alt="JTM" />
      <div class="text">
        <a href="./downloads/buyamerican/jtm_ba.pdf" download>JTM Buy American Statement</a>
      </div>
    </article>
    <article class="card">
      <img src="../assets/logos/tastybrands.png" alt="Tasty Brands" />
      <div class="text">
        <a href="./downloads/buyamerican/tastybrands_ba.pdf" download>Tasty Brands Buy American Statement</a>
      </div>
    </article>
    <article class="card">
      <img src="../assets/logos/wildmikes.jpg" alt="Wild Mikes" />
      <div class="text">
        <a href="./downloads/buyamerican/wildmikes_ba.pdf" download>Wild Mikes Buy American Statement</a>
      </div>
    </article>
    <article class="card">
      <img src="../assets/logos/yangs.png" alt="Yangs 5th Taste" />
      <div class="text">
        <a href="./downloads/buyamerican/yangs_ba.pdf" download>Yangs 5th Taste Buy American Statement</a>
      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
import ImportantDocsTable from "../components/ImportantDocsTable.vue";
import axios from "axios";
//import importantDocsData from "../assets/json data/importantDocs.json";

export default {
  name: "Home",
  data() {
    return {
      importantDocsList: Array,
      isLoading: true,
    };
  },
  mounted() {
    this.getImportantDocsList();
  },
  methods: {
    getImportantDocsList() {
      this.isLoading = true;
      axios
        .get(process.env.VUE_APP_URL + "documents/GetImportantDocList")
        .then((response) => {
          this.importantDocsList = response.data; //JSON.parse(response.data)
          this.isLoading = false;
        });
    },
  },
  components: {
    ImportantDocsTable,
  },
};
</script>
<style scoped>
.grid-container {
  /* display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto;
  gap: 0px 0px;
  grid-template-areas: "left middle right"; */
  display: grid;
grid-template-columns: repeat(5, 1fr);
grid-template-rows: repeat(5, 1fr);
grid-column-gap: 4px;
grid-row-gap: 4px;
}

.left {
  grid-area: left;
}

.middle {
  grid-area: middle;
}

.right {
  grid-area: right;
}
.covid-alert {
  padding: 10px;
  background-color: #f44336; /* Red */
  color: white;
  margin-top: 20px;
}
.covid-alert a {
  font-weight: bold;
}
.covid-alert p {
  padding: 10px;
}
ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}
h4 {
  color: #555;
}

/* roadshow stuff */

.header {
  margin-top: 20px;
}
.list {
  margin-top: 20px;
  text-align: center;
}
.cards {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}
.card {
  flex: 0 0 250px;
  margin: 10px;
  border: 1px solid #ccc;
  box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.3);
}
.card img {
  max-width: 98%;
  max-height: 35%;
  padding: 5px;
}
.card .text {
  padding: 0 10px;
}
/* .card .text .showguide > a {
  color: whitesmoke;
} */

.showguide {
  background: slategray;
  /* color: whitesmoke; */
  padding: 10px;
  margin: 5px auto;
  text-align: center;
  font-weight: bold;
}

.text h3 {
  text-align: center;
}

.card-logo {
  margin-left: auto;
  margin-right: auto;
}

li
{
	vertical-align: bottom;
	text-align: left;
	margin-left: .75em;
  padding-bottom: .5em;
}
</style>
